<template>
  <div class="uren-login-register_area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-xs-12 col-lg-6 m-auto">
          <!-- Login Form s-->
          <form
            @submit.prevent="login"
            @keydown="form.onKeydown($event)"
            class="mt-2"
          >
            <div class="login-form">
              <h4 class="login-title">Login</h4>
              <div class="row">
                <div class="col-md-12 col-12">
                  <label
                    >Email Address <span class="text-danger">*</span></label
                  >
                  <input
                    class="form-control"
                    name="email"
                    :class="{ 'is-invalid': form.errors.has('email') }"
                    type="email"
                    v-model="form.email"
                    placeholder="Email Address"
                  />
                  <has-error :form="form" field="email"></has-error>
                </div>
                <div class="col-12 mb--20">
                  <label>Password <span class="text-danger">*</span></label>
                  <input
                    name="password"
                    v-model="form.password"
                    class="form-control"
                    :class="{ 'is-invalid': form.errors.has('password') }"
                    type="password"
                    placeholder="Password"
                  />
                  <has-error :form="form" field="password"></has-error>
                </div>
                <div class="col-md-12">
                  <div class="forgotton-password_info">
                    Forgotten password?
                    <router-link to="/new-password">
                      Ask a new one.</router-link
                    >
                  </div>
                </div>

                <div class="col-md-12">
                  <!-- <button class="uren-login_btn">Login</button> -->
                  <ButtonLoader
                    :busy="form.busy"
                    type="submit"
                    classes="uren-login_btn"
                    loadText="Logging in..."
                    Text="Login"
                  ></ButtonLoader>
                </div>
                <div class="col-md-12 d-flex justify-content-center mt-4">
                  <img
                    width="100px"
                    src="/images/logo/logo-dxperts.jpeg"
                    alt=""
                    class="img-fluid"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "vform";
import * as services from "@/modules/auth/service/service";

export default {
  name: "Login",
  data() {
    return {
      form: new Form({
        email: "",
        password: "",
      }),
    };
  },

  methods: {
    async login() {
      // Submit the form via a POST request

      await this.form
        .post(services.LOGIN)
        .then((data) => {
          this.$store
            .dispatch("auth/loginSuccess", {
              userp: data.data.client,
              access_tokenp: data.data.token,
              rolep: data.data.role,
            })
            .then(() => {
              this.$router.push({
                name: "home",
              });
            });
        })
        .catch(() => {
          this.$store.dispatch("auth/loginFailure");
        });
    },
  },
  created: function () {
    this.form.email = this.$route.params.email;
    this.form.password = this.$route.params.password;
  },
};
</script>

<style></style>
